import DrawRequestWrapper from './DrawRequestWrapper';
import RequestDraw from './RequestDraw';

export default function WrappedRequestDraw() {
  return (
    <DrawRequestWrapper>
      <RequestDraw />
    </DrawRequestWrapper>
  );
}
